<div class="sb-display-input-radio sb-display-input-radio-icon--{{iconSize}}" *ngIf="title || images.length"
     [ngClass]="{
      'sb-display-input-radio--checked': checked,
      'sb-display-input-radio--lean': lean,
      'sb-display-input-radio--invalid': invalid,
      'sb-display-input-radio--show-radio-button': showRadioButton,
      'sb-display-input-radio--disabled': disabled
     }">

  <ng-container *ngIf="title">
    <!-- region Title -->
    <div class="sb-display-input-radio__title wt-text-bold-l" [ngClass]="{'show-radio-button' : showRadioButton}" *ngIf="showRadioButton">
      <div class="sb-display-input-radio__icon" [ngClass]="{'--checked': !disabled && checked}">
        <div *ngIf="!disabled && checked" class="sb-display-input-radio__icon__inner"></div>
      </div>
      <span [innerHTML]="title | translate"></span>
    </div>
    <div class="sb-display-input-radio__title wt-text-bold-l" *ngIf="!showRadioButton" [innerHTML]="title | translate"></div>
  </ng-container>

  <!-- endregion -->

  <!-- region Images -->
  <div class="sb-display-input-radio__images" [ngClass]="{'show-radio-button' : showRadioButton}" *ngIf="images.length">
    <figure class="sb-display-input-radio__image-container" *ngFor="let image of images">
      <img class="sb-display-input-radio__image" *ngIf="image.src || image.alt" [src]="image.src" [alt]="image.alt | translate">
    </figure>
  </div>
  <!-- endregion -->

</div>
